import { BrowserRouter, Route, Routes, } from "react-router-dom";

import Layout from "./layout/container/Layout";
import Login from "./pages/login/Login";
import Home from "./pages/home/container/Home";
import About from "./pages/about/container/About";
import Feature from "./pages/feature/container/Feature";
import Support from "./pages/support/container/Support";
import Contact from "./pages/contact/container/Contact";

import "./style/main.css"


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="" element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="feature" element={<Feature />} />
            <Route path="support" element={<Support />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/404" element={<h1>Not found</h1>}/>
          <Route path="*" element={<Navigate to={"/404"}/>}/> */}
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
